// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_UpdateItemDeliveryDateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/update_item_delivery_date/{item_id}
 *
 * Returns the updated expected_delivery_at (ISO 8601 UTC) and the
 * single new history entry that was just created.
 */
import type { Orders_DeliveryDateHistoryRow } from './Orders_DeliveryDateHistoryRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_UpdateItemDeliveryDateResponseDados {
item_id: number
expected_delivery_at: string
history_entry: Orders_DeliveryDateHistoryRow
}

export type Orders_UpdateItemDeliveryDateResponse = ApiResponse<Orders_UpdateItemDeliveryDateResponseDados>;

registerResponseContract('Orders_UpdateItemDeliveryDateResponse', {
  item_id:              { type: 'number',  required: true },
  expected_delivery_at: { type: 'string',  required: true },
  history_entry: {
    type: 'object',
    required: true,
    fields: {
      so_oidh_id:              { type: 'number',  required: true },
      so_oidh_order_item_id:   { type: 'number',  required: true },
      so_oidh_previous_date:   { type: 'string',  required: false },
      so_oidh_new_date:        { type: 'string',  required: true },
      so_oidh_reason:          { type: 'string',  required: true },
      so_oidh_changed_by:      { type: 'string',  required: true },
      so_oidh_changed_by_name: { type: 'string',  required: false },
      so_oidh_changed_at:      { type: 'string',  required: true },
    },
  },
})
